// Contents of this file are automagically put into a document.ready function

'use strict';

/* 
 * Search Functionality
 */

// Search trigger functionality
let search_triggers = document.querySelectorAll( 'form.wp-block-search:not(.search-overlay-form) button.wp-block-search__button' );
let search_overlay = document.querySelector( '#search-overlay' );
let content = document.querySelector( 'html' );

for (var i = 0; i < search_triggers.length; i++) {
	// Remove default WP click functionality
	search_triggers[i].setAttribute( 'data-wp-on--click', '' );
	// Set aria-label 
	search_triggers[i].setAttribute( 'aria-label', 'Search' );
	// Add manual click event
	search_triggers[i].addEventListener( 'click', showSearchOverlay );
}

function showSearchOverlay() {
	if ( search_overlay ) {
		search_overlay.classList.add( 'active' );
		content.classList.add( 'overlay-active' );
		search_overlay.querySelector( '.wp-block-search__input' ).focus();
	}
	return false;
}

// Search close functionality
let search_close = document.querySelector( '#search-overlay-close a' );

// Add aria labels to button
if ( search_close ) {
	search_close.setAttribute( 'aria-label', 'Close Search Overlay' );
	search_close.setAttribute( 'tabindex', '0' );
}

search_close.onclick = function(){
	search_overlay.classList.remove( 'active' );
	content.classList.remove( 'overlay-active' );
	return false;
}



/* 
 * Slider Design
 */
window.addEventListener('load', function () {
	loadArrows();
}, true);

window.addEventListener('resize', function(event) {
	loadArrows();
}, true);

// Stackable slider button configurations
function loadArrows() {
	let sliders = document.querySelectorAll('.wp-block-stackable-carousel');

	for (var i = 0; i < sliders.length; i++) {
		let this_slider = sliders[i];
		let container = this_slider.querySelectorAll('.stk-block-carousel__dots');
		let next_btn = this_slider.querySelectorAll('.stk-block-carousel__button__next')[0].cloneNode( true );
		let prev_btn = this_slider.querySelectorAll('.stk-block-carousel__button__prev')[0].cloneNode( true );

		// Check if arrows have already been added to the carousel dots
		let arrows = container[0].querySelector( '.stk-block-carousel__button' );

		if ( null === arrows ) {

			if ( container ) {
				if ( prev_btn ) {
					container[0].prepend(prev_btn);
				}
				if ( next_btn ) {
					container[0].append(next_btn);
				}
			}

			// Add event listener for cloned previous button
			this_slider.querySelectorAll('.stk-block-carousel__dots .stk-block-carousel__button__prev')[0].addEventListener('click', e => {
				this_slider.querySelectorAll('.stk-block-carousel__buttons .stk-block-carousel__button__prev')[0].click();
			});

			// Add event listener for cloned next button
			this_slider.querySelectorAll('.stk-block-carousel__dots .stk-block-carousel__button__next')[0].addEventListener('click', e => {
				this_slider.querySelectorAll('.stk-block-carousel__buttons .stk-block-carousel__button__next')[0].click();
			});
		}
	}
}